import React from 'react';

export const SizedBox: React.FC<{ width?: number; height?: number }> = props => {
  return <div style={{ width: props.width, height: props.height }} />;
};
